import { useCampaignsOverviewCRUDActions } from '@mm/state/actions/CampaignsOverviewCRUDActions';
import { selectRecordsByUiFilterKind } from '@mm/state/selectors/campaignsOverviewSelectors';
import { activeChatbotIdSelector } from '@mm/state/selectors/viewSelectors';
import { StoreState } from '@mm/state/store-interfaces';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router';

import { BotBuilderRoutes } from '../../../../../routes/bot-builder-routes';

import { useCreateCampaignHandlers } from '../Campaigns/use-create-campaign-handlers';
import { AutomationTemplateName } from './AutomationHome/TemplateIndex/Templates/TemplateDefinitions';
import { CampaignAudienceAttribute } from '@mm/state/model/CampaignsModel';

export const useAutomations = () => {
  const chatbotId = useSelector(activeChatbotIdSelector);
  const history = useHistory();

  const campaignCRUDActions = useCampaignsOverviewCRUDActions();
  const campaignHandlers = useCreateCampaignHandlers();

  const { campaigns: automations, pagination } =
    useSelector((state: StoreState) =>
      selectRecordsByUiFilterKind(state, 'automation'),
    ) || {};

  const [busy, setBusy] = useState(false);

  const fetchAutomations = async (
    {
      page,
      perPage,
      search,
      mergeResults,
    }: {
      page?: number;
      perPage?: number;
      search?: string;
      mergeResults?: boolean;
    } = { page: undefined, perPage: undefined },
  ) => {
    setBusy(true);
    try {
      const res = await campaignCRUDActions.retrieveAll({
        botId: chatbotId,
        kind: 'automation',
        search,
        pagination: {
          page: page || pagination?.page || 1,
          perPage: perPage || pagination?.perPage || 8,
        },
        mergeResults,
      });
      return res?.payload;
    } finally {
      setBusy(false);
    }
  };

  const createAutomation = async (
    template: AutomationTemplateName,
    templateParams: any,
    botIdOverride?: number,
    campaignAudiencesAttributes?: CampaignAudienceAttribute[],
  ) => {
    if (chatbotId) {
      const automation = (await campaignHandlers.createByKind(
        'automation',
        template,
        templateParams,
        botIdOverride,
        campaignAudiencesAttributes,
      )) as any;

      if (automation?.id) {
        history.push(
          BotBuilderRoutes.automationEdit.getLink({
            chatbotId,
            id: automation.id,
          }),
          { firstTime: true },
        );
      }

      return automation;
    }
  };

  return { createAutomation, fetchAutomations, automations, busy, pagination };
};
